// extracted by mini-css-extract-plugin
export var animationContainer = "_ew-0";
export var asteriskIcon = "_ew-8";
export var conversationLeftSection = "_ew-4";
export var conversationListItem = "_ew-3";
export var conversationMiddleSection = "_ew-5";
export var conversationRightSection = "_ew-6";
export var detailsContent = "_ew-1";
export var listContainer = "_ew-7";
export var modalContent = "_ew-2";